import { Coin } from "@/icons/Coin.tsx";
import { FolderImage } from "@/icons/FolderImage.tsx";
import { UserPlus } from "@/icons/UserPlus.tsx";
import { WandMagicSparkles } from "@/icons/WandMagicSparkles.tsx";
import { getStats } from "@/services/stats.service.ts";
import useUserStore from "@/store/user.store.ts";
import { Button, Timeline, Text, Card, Flex } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Link } from "react-router";

export function GettingStartedCard() {
  const { user } = useUserStore();
  const { data } = useQuery({
    queryKey: ["stats"],
    queryFn: () => getStats(),
  });
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (data?.credits === 0) {
      setActive(0);
      return;
    }

    if (data?.characters === 0) {
      setActive(1);
      return;
    }

    if (data?.photos === 0) {
      setActive(2);
      return;
    }

    setActive(3);
  }, [data]);

  if (active === 3 && user?.created_at) {
    const daysSinceCreation = dayjs().diff(dayjs(user.created_at), "day");
    if (daysSinceCreation >= 2) {
      return null;
    }
  }

  return (
    <Card withBorder shadow="sm">
      <Card.Section withBorder p="lg">
        <Text size="lg" fw={500}>
          Let's get started!
        </Text>
      </Card.Section>
      <Card.Section withBorder p="lg">
        <Timeline active={active} bulletSize={24} lineWidth={2}>
          <Timeline.Item bullet={<Coin size={12} />} title="Add credits">
            <Flex direction="column" gap={8}>
              <Text c="dimmed" size="sm">
                Buy some credits by topping up your account or by activating a
                subscription.
              </Text>
              <Button
                component={Link}
                to="/billing"
                variant="default"
                size="xs"
              >
                Buy credits
              </Button>
            </Flex>
          </Timeline.Item>

          <Timeline.Item
            bullet={<UserPlus size={12} />}
            title="Train an AI character"
          >
            <Flex direction="column" gap={8}>
              <Text c="dimmed" size="sm">
                Upload at least 10 photos to train your first AI character.
              </Text>
              <Button
                component={Link}
                to="/characters"
                variant="default"
                size="xs"
              >
                Create character
              </Button>
            </Flex>
          </Timeline.Item>

          <Timeline.Item
            bullet={<FolderImage size={12} />}
            title="Generate AI photos"
            lineVariant="dashed"
          >
            <Flex direction="column" gap={8}>
              <Text c="dimmed" size="sm">
                Generate your first AI photos using your trained character.
              </Text>
              <Button
                component={Link}
                to="/playground"
                variant="default"
                size="xs"
              >
                Generate photos
              </Button>
            </Flex>
          </Timeline.Item>

          <Timeline.Item
            title="Explore our packs and templates"
            bullet={<WandMagicSparkles size={12} />}
          >
            <Flex direction="column" gap={8}>
              <Text c="dimmed" size="sm">
                Generate pre-set AI photos using our quick packs or by
                replicating our templates in the Explore section.
              </Text>
              <Button component={Link} to="/packs" variant="default" size="xs">
                Explore
              </Button>
            </Flex>
          </Timeline.Item>
        </Timeline>
      </Card.Section>
    </Card>
  );
}
